import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";
import React from "react";
import {
  ChipField,
  Datagrid,
  DeleteWithConfirmButton,
  EditButton,
  List,
  ReferenceArrayField,
  SimpleList,
  SingleFieldList,
  TextField,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { MOBILE_BREAKPOINT } from "utils/constants";

const ListSpecialitiesGroups = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Списък групи специалности"
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={() => <MobileListRow fields={[{ label: "Група", value: <TextField source="description" /> }]} />}
          secondaryText={() => (
            <MobileListRow
              fields={[
                {
                  label: "Специалности",
                  value: (
                    <ReferenceArrayField
                      source="specialityIds"
                      reference={administrationRequests.getSpecialitiesSelect()}
                    >
                      <SingleFieldList linkType={false}>
                        <ChipField source="name" />
                      </SingleFieldList>
                    </ReferenceArrayField>
                  ),
                },
              ]}
            />
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageSpecialityGroups}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canManageSpecialityGroups}>
                <DeleteWithConfirmButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="description"
            label="Група"
            sortable={false}
          />
          <ReferenceArrayField
            label="Специалности"
            source="specialityIds"
            reference={administrationRequests.getSpecialitiesSelect()}
            sortable={false}
          >
            <SingleFieldList linkType={false}>
              <ChipField source="name" />
            </SingleFieldList>
          </ReferenceArrayField>
          <SecuredComponent permission={permissions.canManageSpecialityGroups}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canManageSpecialityGroups}>
            <DeleteWithConfirmButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListSpecialitiesGroups;
